import React from "react";
import "./Quiz.css";
import "./LandingPage.css";

function Result({ score, total, restart }) {
  return (
    <div className="landing-container">
      <h2>Your score: {score} / {total}</h2>
      <button onClick={restart} className="category-button">Go Back to Categories</button>
    </div>
  );
}

export default Result;
